import React from 'react';
import { connect } from 'react-redux';
import payIcon from 'images/LP-MakePayment2-V_D_MC.png';
import $ from 'jquery';
import css from '../styles/contact.css';
import AOS from 'aos';

const { Component } = React;

const EMAIL_REGEX = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

class Contact extends Component {
  constructor() {
    super();
    this.state = {
      pending: false,
      error: false,
      comfirm: false,
      email: null,
      body: null
    };

    this._onChange = this._onChange.bind(this);
    this._onSubmit = this._onSubmit.bind(this);
    this._isSubmitDisabled = this._isSubmitDisabled.bind(this);
  }

  componentDidMount() {
    AOS.refreshHard();
  }

  _onChange(e) {
    let state = {};
    state[e.target.name] = $.trim(e.target.value);
    this.setState(state);
  }

  _onSubmit(e) {
    e.preventDefault();
    this.setState({ pending: true, error: false, success: false});

    $.ajax({
      type: 'POST',
      url: '/api/contact',
      data: {
        email: this.state.email,
        body: this.state.body
      },
      success: this._onSuccess.bind(this),
      error: this._onError.bind(this),
      dataType: 'json'
    });
  }

  _onSuccess(response) {
    this.setState({ pending: false, confirm: true });
    this.refs.contact_form.reset();
  }

  _onError(reason) {
    this.setState({ pending: false, error: true });
  }

  _isSubmitDisabled() {
    let emailValid = this._validateEmail(this.state.email);
    let bodyValid = this._validateBody(this.state.body);
    return !(emailValid && bodyValid)
    //return this._validateEmail(this.state.email) && this._validateBody(this.state.body);
  }

  _validateEmail(email) {
    return EMAIL_REGEX.test(email);
  }

  _validateBody(body) {
    return body !== null && body.length > 5;
  }

  render() {
    if (this.state.confirm) {
      return this.renderConfirmation();
    } else {
      return this.renderBase();
    }
  }

  renderConfirmation() {
    return (
      <div className="contact">
        <div className="contact-wrapper">
          <h3 className="contact-confirm-text">Thank you for your submission!</h3>
        </div>
      </div>
    );
  }

  renderBase() {
    let spinnerClasses = ['contact-spinner'];
    if (this.state.pending) {
      spinnerClasses.push('contact-spinner--active');
    }

    let errorClasses = ['contact-error'];
    if (this.state.error) {
      errorClasses.push('contact-error--active');
    }

    return (
      <div className="contact">
        <div className={spinnerClasses.join(' ')}>
          <div className="loader"></div>
        </div>
        <div className="contact-wrapper">
          <h1>Contact Information</h1>
          <div className="contact-address-block">
            <div className="contact-address-item">
              <p>Ben F. Meek, III</p>
              <p>Attorney at Law</p>
              <p>Landmark Towers West</p>
              <p>Suite 1000</p>
              <p>3555 NW 58th Street</p>
              <p>Oklahoma City, Oklahoma 73112</p>
            </div>
            <div className="contact-address-item">
              <a class="bfm-link" href="tel:4057244454">405.724.4454</a>
            </div>
          </div>
          <p className="contact-prompt">Leave me a note with your e-mail address and let me help you!</p>
          <form ref="contact_form" onSubmit={this._onSubmit}>
            <label>Email
              <input className="u-full-width contact-email" name="email" type="email" placeholder="user@site.com" onChange={this._onChange}/>
            </label>
            <label>Please give me some information about your situation.
              <textarea className="contact-body" name="body" onChange={this._onChange}/>
            </label>
            <button disabled={this._isSubmitDisabled()} className="button-primary contact-submit" type="submit">Submit</button>
            <div className={errorClasses.join(' ')}>
              <p> Unable to submit.  Please try again later</p>
            </div>
          </form>
          <div className="contact-payment-block">
            <h1>Payments</h1>
            <h3>You can pay bills or a make retainer payments by Credit Card.  Such payments are processed through my LawPay portal, which is a safe and secure web portal designed for lawyers and approved for use in Oklahoma.  Simply click on one of the following links. </h3>
            <div class="contact-payment__pay-icon-wrapper">
              <div class="contact-payment__pay-icon">
                <img src={payIcon} />
              </div>
            </div>
            <div className="contact-payment-block__split">
              <div className="contact-payment-block__split-left">
                <h4>Pay an invoice or a bill?</h4>
                <em>use this link to pay your regular bills</em>
                <div class="contact-payment-block__split-action">
                  <a href="https://secure.lawpay.com/pages/bfm3law/operating">Invoices & Bills</a>
                </div>
              </div>
              <div className="contact-payment-block__split-right">
                <h4>Pay or replenish a retainer</h4>
                <em>retainer payments go into my client trust account</em>
                <div class="contact-payment-block__split-action">
                  <a href="https://secure.lawpay.com/pages/bfm3law/trust">Retainer</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {};
}

const ContactContainer = connect(mapStateToProps, mapDispatchToProps)(Contact);

export {Contact, ContactContainer};



// WEBPACK FOOTER //
// ./app/screens/App/screens/Contact/components/contact.js